export const FOOTER_TEXT_DEFAULTS = {
  company_name: 'Walravens Watering System SRL',
  copyright: '© {year} {site_name} — exploité par {company_name}.',
  legal_notice: '{company_name} — Tous droits réservés — Belgique',
  legal_note: 'Ce document est susceptible d\'être modifié. La version en vigueur est celle publiée sur cette page.',
};

/** Remplace {year}, {site_name}, {company_name} dans un texte du pied de page. */
export function footerText(template, footer, siteName) {
  const f = { ...FOOTER_TEXT_DEFAULTS, ...(footer || {}) };
  return String(template || '')
    .replace(/\{year\}/g, String(new Date().getFullYear()))
    .replace(/\{site_name\}/g, siteName || 'Ernest & Marguerite')
    .replace(/\{company_name\}/g, f.company_name || FOOTER_TEXT_DEFAULTS.company_name);
}

/** Lignes légales (pages CGV, mentions, RGPD…) depuis la config footer. */
export function legalNotice(footer, siteName) {
  const f = { ...FOOTER_TEXT_DEFAULTS, ...(footer || {}) };
  return { notice: footerText(f.legal_notice, f, siteName), note: footerText(f.legal_note, f, siteName), company: f.company_name };
}
